import "./CustomTextArea.scss";

import React, { useEffect, useRef, useState } from "react";

interface IProps {
  defaultText: { value: string };
  onChange: (text: string) => void;
  isAnswer?: boolean;
  label?: string;
  placeholder?: string;
  onEnter?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  value?: string;
  disabled?: boolean;
  autofocus?: boolean;
  wrapperClassName?: string;
  placeholderClassName?: string;
}

const CustomTextArea: React.FC<IProps> = ({
  defaultText,
  isAnswer,
  label,
  onChange,
  placeholder,
  onEnter,
  value,
  disabled,
  autofocus,
  wrapperClassName = "",
  placeholderClassName = "",
}) => {
  const inputRef = useRef<HTMLDivElement>(null);

  const [_, setInputValue] = useState<string>("");

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.innerHTML = defaultText.value;
      autofocus && inputRef.current.focus();
    }
  }, [defaultText, autofocus]);

  const handleInput = (e: React.FormEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    const text = target.innerHTML === "<br>" ? "" : target.innerText;
    onChange(text || "");
    setInputValue(text || "");
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
    onChange(inputRef.current?.innerText || "");
    setInputValue(inputRef.current?.innerText || "");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && onEnter) {
      onEnter(e);
    }
  };

  return (
    <>
      {label?.length && (
        <label className="input__label form-label">{label}</label>
      )}
      <div className={`input__wrapper ${wrapperClassName}`}>
        <div
          className={`input__textarea ${
            isAnswer ? "input__textarea input__textarea--answer" : ""
          }`}
          data-testid="custom-text-area"
          contentEditable={!disabled}
          suppressContentEditableWarning={true}
          onInput={handleInput}
          onPaste={handlePaste}
          ref={inputRef}
          onKeyDown={handleKeyDown}
        />
        {!value && placeholder && (
          <div className={`input-placeholder ${placeholderClassName}`}>
            {placeholder}
          </div>
        )}
      </div>
    </>
  );
};

export { CustomTextArea };
